import React from 'react'
import FormStudentsGroup from '../components/FormStudentsGroup'
import hipladeTemplate from '../../common/template'
import FormStudentsGroupV2 from '../components/FormStudentsGroupV2'

function StudentsGroupForm() {
  return <FormStudentsGroupV2 />
}

export default hipladeTemplate(StudentsGroupForm)
